import { handleAuthToken } from "@pathwright/auth/src/lib/utils/auth-token"
import { useEffect } from "react"
import { StringParam, useQueryParam } from "use-query-params"
import { useGetTokenViaSsoMutation } from "@pathwright/graphql-client/src/generated"

// Hook for handling the ?sso query param in local development
// for authenticating super users. The backend handles the ?sso
// query param already, but we need this for local dev.
function useLocalDevSSO() {
  const [ssoToken, setSSOQueryParam] = useQueryParam("sso", StringParam)
  const [getTokenViaSso, { loading }] = useGetTokenViaSsoMutation({
    // Once completed, handle the auth token (by signing in the user) and remove the query param.
    onCompleted(data) {
      const token = data.getTokenViaSSO?.token
      if (token) {
        handleAuthToken(token)
      } else {
        console.error(
          `Failed to retrieve auth token via SSO token in query params. Removing. Token: ${ssoToken}`
        )
      }
      // Always remove the sso query param after using it.
      setSSOQueryParam(undefined, "replaceIn")
    }
  })

  useEffect(() => {
    if (ssoToken && process.env.NODE_ENV === "development") {
      // Handle the special case where ssoToken is the string "undefined" which can
      // somehow happen due to app routing, like when closing a card. Unsure why, so
      // catching the case here for now.
      if (ssoToken === "undefined") {
        setSSOQueryParam(undefined, "replaceIn")
      } else {
        getTokenViaSso({ variables: { ssoToken } })
      }
    }
  }, [ssoToken])

  // We are awaiting auth if we have an sso token to process or if the mutation is loading.
  const awaitingAuth = !!ssoToken || loading

  return awaitingAuth
}

export default useLocalDevSSO
